import React, { useContext } from 'react';
import DialogModal from '@/modules/common/components/Modal/DialogModal';
import { Button, Typography, useToast } from '@pw-tech/omni-ui';
import Image from 'next/image';
import { useReRegister } from '@/modules/RegisterLayout/hooks/useReRegister';
import { RegistrationContext } from '@/modules/RegisterLayout/contexts/RegistrationContextProvider';
import { useRouter } from 'next/router';
const ReAttempt = ({
  onClose
}: {
  onClose: () => void;
}) => {
  const {
    registrationDetails,
    submitRegisterForm
  } = useContext(RegistrationContext);
  const {
    mutate,
    isPending
  } = useReRegister();
  const {
    toast: showToaster
  } = useToast();
  const router = useRouter();
  const handleReAttempt = () => {
    mutate({
      applicationId: registrationDetails?._id,
      batchId: registrationDetails?.batchId,
      courseId: registrationDetails?.courseId
    }, {
      onSuccess: async (response: any) => {
        showToaster({
          message: 'New Application Started Successfully!',
          variant: 'success',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center'
          }
        });
        await submitRegisterForm({
          step: 1
        }, true);
      }
    });
  };
  return <>
      <DialogModal isOpen title="" onClose={onClose} showHeader={false} showSeparator={false} showFooter={false} showCancelButton={false} showCloseIcon={false} showSubmitButton={false} closeOnOutsideClick size="extra-small" data-sentry-element="DialogModal" data-sentry-source-file="ReAttempt.tsx">
        <div className="flex flex-col items-center gap-4">
          <Image src="https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/b1c3ccca-e784-4414-ad74-01a95e5ad701.png" alt="reattempt-icon" className="rounded-full" width={100} height={100} data-sentry-element="Image" data-sentry-source-file="ReAttempt.tsx" />
          <div className="flex flex-col items-center text-center">
            <Typography variant="heading4" weight="semi-bold" data-sentry-element="Typography" data-sentry-source-file="ReAttempt.tsx">
              Are you sure you want to re-attempt CEE?
            </Typography>
            <Typography variant="heading4" className="!text-[#3D3D3D]" data-sentry-element="Typography" data-sentry-source-file="ReAttempt.tsx">
              By selecting 'Re-attempt' your previous application will be entirely erased, and a
              fresh application will be initiated
            </Typography>
          </div>
          <div className="flex gap-2">
            <Button variant="lowFocus" className="!text-[#196CDC]" onClick={onClose} data-sentry-element="Button" data-sentry-source-file="ReAttempt.tsx">
              Cancel
            </Button>
            <Button variant="primary" onClick={handleReAttempt} disabled={isPending} data-sentry-element="Button" data-sentry-source-file="ReAttempt.tsx">
              {isPending ? 'Re-attempting...' : 'Re-attempt'}
            </Button>
          </div>
        </div>
      </DialogModal>
    </>;
};
export default ReAttempt;